import { render } from "./PanelAbstracts.vue?vue&type=template&id=2a26937a&scoped=true&ts=true"
import script from "./PanelAbstracts.vue?vue&type=script&lang=ts"
export * from "./PanelAbstracts.vue?vue&type=script&lang=ts"

import "./PanelAbstracts.vue?vue&type=style&index=0&id=2a26937a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a26937a"]])

export default __exports__